export default __webpack_public_path__ + "static/media/15-min.646da660.jpg";